import { render, staticRenderFns } from "./Achieved.vue?vue&type=template&id=388012f5"
import script from "./Achieved.vue?vue&type=script&lang=js"
export * from "./Achieved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports